/**
 * Canonical alt text for the portrait / hero imagery.
 *
 * Alt text is written for a screen-reader user, not for a crawler:
 *  - it describes what is *visible* (who, wearing what, framing),
 *  - it is one short sentence, no credential list, no keyword stuffing
 *    (repeating "PsyD · ThD · DMin · CERC" in every alt makes the page
 *    hostile to listen to, and search engines discount stuffed alt anyway —
 *    the credentials live in visible copy and in the Person JSON-LD),
 *  - it never starts with "Image of" / "Photo of" (announced already).
 *
 * Keep every entry under ~125 characters — most screen readers truncate
 * around there.
 */

export const IMAGE_ALT = {
  /** Homepage hero portrait. */
  heroHome:
    "Dr. RD Sully Sullivan in his signature orange suit, arms folded, in a three-quarter editorial portrait",

  /** Masterclass hero portrait. */
  heroMasterclass:
    "Dr. RD Sully Sullivan, host of the Built On Purpose Masterclass, in his signature orange suit",

  /** About-page portrait. */
  aboutPortrait:
    "Dr. RD Sully Sullivan in his signature orange blazer, looking toward the camera in an editorial portrait",

  /** QA harness previews — still descriptive so the QA pages stay auditable. */
  qaHeroFrame: "Hero crop preview: Dr. RD Sully Sullivan in his orange suit",
  qaAboutFrame: "About crop preview: Dr. RD Sully Sullivan in his orange blazer",
} as const;

export type ImageAltKey = keyof typeof IMAGE_ALT;

/** Longest alt we allow before screen readers start truncating. */
export const ALT_MAX_LENGTH = 125;
